export default (state, { id }) => state.administrators.data && id && state.administrators.data[id]
